import axios from 'axios';
export const Plans = (
  token: string,
  plantype: number
): Promise<{ planstatus: number; plandata: any }> => {
  const url = `${process.env.REACT_APP_COMMENT_STREAM_BACKEND_URL}/plandetails`;

  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: { plantype: plantype },
        headers: {
          Authorization: `Bearer ${token}`,
          'ngrok-skip-browser-warning': 'true',
        },
      })
      .then((response) => {
        console.log(response, 'general service');
        if (response.status === 200) {
          resolve({
            planstatus: response.status,
            plandata: response.data,
          });
        } else {
          reject({ status: response.status });
        }
      })
      .catch((error) => {
        console.error('Error fetching user details:', error);
        reject({
          status: 500,
          message: error.message || 'Unknown error occurred',
        });
      });
  });
};
